export default __webpack_public_path__ + "static/media/OneDrop.e2f95eb3.jpg";